import React from 'react';
import SectionHeader from './ui/SectionHeader';
import useRevealOnScroll from '../hooks/useRevealOnScroll';

const policyGroups = [
  {
    title: 'Check-in & Stay Times',
    items: ['Check-in: 2:00 PM to 11:00 PM', 'Check-out: Before 11:00 AM']
  },
  {
    title: 'Payment & Identification',
    items: [
      'Guests must present a photo ID and a credit card at check-in.',
      'Accepted cards: Visa and Mastercard.',
      'Special requests depend on availability and may include extra charges.'
    ]
  },
  {
    title: 'Occupancy & House Rules',
    items: [
      'No smoking and no pets.',
      'One child under 4 stays free when using existing beds.',
      'Older children or adults: CAD 10 per person, per night using existing beds.',
      'Maximum extra beds per room: 1, upon management confirmation and extra charge.',
      'Cribs are not available in rooms.',
      'Additional fees are charged separately and are not included automatically in total cost.'
    ]
  }
];

const PolicyIcon = () => (
  <svg className="h-6 w-6 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <path d="M12 8v4l2.2 2.2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="12" r="9" />
  </svg>
);

const PoliciesSection = () => {
  const { ref, isVisible } = useRevealOnScroll();

  return (
    <section id="policies" className="section-shell pt-0">
      <div ref={ref} className={`card-surface p-8 md:p-12 ${isVisible ? 'reveal-visible' : ''} reveal`}>
        <SectionHeader
          eyebrow="Policies"
          title="Clear expectations for a smooth stay"
          subtitle="Key policies are grouped below for easier review before booking."
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {policyGroups.map((group) => (
            <article key={group.title} className="rounded-2xl border border-brand-border bg-[#fbf7ef] p-6">
              <div className="mb-4 flex items-center gap-3">
                <PolicyIcon />
                <h3 className="font-heading text-2xl text-brand-primary">{group.title}</h3>
              </div>
              <ul className="list-disc space-y-2 pl-5 text-sm leading-relaxed text-brand-muted">
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PoliciesSection;
